'use strict';

angular.module('ecrd.queries', [
    'ecrd.core',
    'ecrd.records',
    'table-settings',
    'sharecrf-sdk',
    'app.study-context',
]);
